export function OrganizationSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '韩漫漫画',
          url: 'https://hanmancomic.com',
          description:
            '韩漫漫画网站汇集免费韩漫在线漫画网站推荐大全，支持无删减下拉式韩漫免费阅读，资源优质更新及时。',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@hanmancomic.com',
            contactType: 'customer service',
          },
          address: {
            '@type': 'PostalAddress',
            addressLocality: '首尔',
            addressRegion: '首尔特别市',
            addressCountry: 'KR',
          },
        }),
      }}
    />
  );
}

export function WebsiteSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '韩漫漫画',
          url: 'https://hanmancomic.com',
          description:
            '免费韩漫在线漫画网站推荐大全 - 支持无删减下拉式韩漫免费阅读',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://hanmancomic.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }),
      }}
    />
  );
}

export function WebPageSchema({
  title,
  description,
  url,
  datePublished,
  dateModified,
}: {
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: title,
          description,
          url: `https://hanmancomic.com${url}`,
          ...(datePublished && { datePublished }),
          ...(dateModified && { dateModified }),
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫漫画',
            url: 'https://hanmancomic.com',
          },
        }),
      }}
    />
  );
}

export function ArticleSchema({
  title,
  description,
  url,
  imageUrl,
  datePublished,
  dateModified,
  authorName,
}: {
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
}) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: title,
          description,
          url: `https://hanmancomic.com${url}`,
          image: imageUrl,
          datePublished,
          dateModified,
          author: {
            '@type': 'Person',
            name: authorName,
          },
          publisher: {
            '@type': 'Organization',
            name: '韩漫漫画',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `https://hanmancomic.com${url}`,
          },
        }),
      }}
    />
  );
}

export function FAQSchema({
  faqs,
}: {
  faqs: { question: string; answer: string }[];
}) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }),
      }}
    />
  );
}